module.exports = __webpack_public_path__ + "static/media/cba2016_paper.71fdb47f.png";